import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyDnVvQgr7izboWssLbTh3pWAXEp5heRVXk",
    authDomain: "pogoz-33ec6.firebaseapp.com",
    projectId: "pogoz-33ec6",
    storageBucket: "pogoz-33ec6.appspot.com",
    messagingSenderId: "481149673399",
    appId: "1:481149673399:web:a67bbdd73d7a2753bcd232",
    measurementId: "G-KNXNE85ZGC"
};

firebase.initializeApp(firebaseConfig);

export default firebase;